import { lazyPage } from '@/lib/lazy-load'

const MyNotificationsPage = lazyPage(() => import('./MyNotificationsPage'))
export default MyNotificationsPage
